export const getFormattedSlug = (str: string) => {
  return str.toLowerCase().trim().split(' ').join('-');
};
